// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"wNfLz","smallLinkTypography":"_2J5VB","titleTypography":"_3MS45","cardTitleTypography":"_1Z1eP","truncate":"xy8V9","base":"_3hhvQ","content":"_2DLm8","sectionTopHeader":"_27s3g","section":"_1EckB","sectionTitle":"_2DKxo","sectionContent":"_1Qh16","sectionLoading":"_1KD2F","sectionFooter":"_1Mti3","sectionFrame":"_2y42S","sectionTopHeaderTrx":"_2iGb_","sectionAlertTrx":"wIfGl","linkButton":"aCogi","button":"aUz3q","tip":"_1IOqL","panel":"dhjZj"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/AccountsAndLoans.scss
// module id = 471
// module chunks = 0